"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import Reviewslidercomponents from "@packages/shared-components/common-utilities/slider/reviewslidercomponents";
import { StarIcon } from "@packages/shared-components/user-profile/signin-signup/media-utilities/mediautilities";
import { ReviewDetailsList } from "@packages/lib/types/interfaces";

interface UniversityCardProps {
  logoSrc: string;
  name: string;
  rating: string;
  reviewCount: string;
  backgroundImage: string;
  courseName?: string;
  maxSlidesPerView?: number;
  sliderClassName?: string;
  noRoundedRight?: boolean;
  totalCards?: number;
  headingClassName?: string;
  autoplay?: boolean;
  rev_Navigation?: boolean;
  hideReadMore?: boolean;
  mobileSpaceBetween?: number;
  collegeId?: string;
  reviews?: ReviewDetailsList["reviewDetail"];
}

const UniversityCard = ({
  logoSrc,
  name,
  rating,
  reviewCount,
  backgroundImage,
  courseName,
  sliderClassName,
  noRoundedRight = false,
  headingClassName,
  autoplay = false,
  rev_Navigation = false,
  hideReadMore = true,
  mobileSpaceBetween,
  collegeId = "0",
  reviews = [],
}: UniversityCardProps) => {

  const roundedClass = noRoundedRight
    ? "rounded-none lg:rounded-tl-[8px] lg:rounded-tr-none"
    : "rounded-none lg:rounded-t-[8px]";

  const filteredReviews = reviews
    .filter((r) => parseFloat(r.overallRating) > 4 && r.comment.length > 120)
    .sort((a, b) => {
      const ratingDiff =
        parseFloat(b.overallRating) - parseFloat(a.overallRating);
      if (ratingDiff !== 0) return ratingDiff;
      return new Date(b.to_char).getTime() - new Date(a.to_char).getTime();
    })
    .slice(0, 5);

  return (
    <div className={`flex flex-col gap-[24px]`}>
      <div
        className={`w-full h-[292px] relative bg-primary-500 shrink-0 ${roundedClass} cursor-pointer overflow-hidden`}
      >
        <div
          className={`absolute inset-0 p-[16px] bg-gradient17 lg:p-[24px] flex flex-col justify-between ${roundedClass} z-10`}
        >
          <Link
            href="#"
            className="w-[64px] h-[64px] p-[4px] rounded-[4px] bg-white shadow-custom-4 flex items-center justify-center shrink-0"
          >
            <Image src={logoSrc} alt="University logo" width={56} height={56} />
          </Link>
          <div className="flex flex-col gap-[4px] text-white">
            <div className="para-lg font-farro fontsemibold">{name}</div>
            {courseName && (
              <div className="small text-grey-50">{courseName}</div>
            )}
            <div className="flex items-center gap-[8px] text-grey-50 small">
              <div className="flex items-center gap-[2px]">
                <StarIcon />
                {rating}
              </div>
              <Link href="" className="hover:underline">
                {reviewCount} reviews
              </Link>
            </div>
          </div>
        </div>
        <Image
          src={backgroundImage}
          alt="University"
          fill
          className={`${roundedClass} object-cover`}
        />
      </div>
      {!!filteredReviews?.length && 
      <div className="flex flex-col gap-[16px]">
        <div className={`h6 ${headingClassName || "px-[16px] md:px-[0]"}`}>
          What students say
        </div>
        <Reviewslidercomponents
          reviewData={filteredReviews}
          pageName={"Degree"}
          parent_category=""
          sub_Category=""
          rev_CardCount={1}
          rev_className={sliderClassName}
          autoplay={autoplay}
          rev_Navigation={rev_Navigation}
          hideReadMore={hideReadMore}
          mobileSpaceBetween={mobileSpaceBetween}
          cardClassName="min-h-[220px]"
          />
      </div>
        }
    </div>
  );
};

export default UniversityCard;
